import { AuthClientTokens } from "@react-keycloak/core/lib/types";
import { AuthConfig } from "../domain/authConfig";
import { Buffer } from "buffer";
import { LOCAL_STORAGE_SUFFIX } from "../constants/environment";

const getFPKT = ({
  client,
  appName,
}: AuthConfig): AuthClientTokens | undefined => {
  const encodedToken =
    localStorage.getItem(`${client}-${appName}-${LOCAL_STORAGE_SUFFIX}`) || "";
  const decodedToken = Buffer.from(encodedToken, "base64").toString("ascii");
  return decodedToken
    ? (JSON.parse(decodedToken) as AuthClientTokens)
    : undefined;
};

const removeFPKT = () => {
  Object.entries({ ...localStorage }).forEach(([key]) => {
    key.endsWith(LOCAL_STORAGE_SUFFIX) && localStorage.removeItem("" + key);
  });
};

const setFPKT = ({ client, appName }: AuthConfig, token: AuthClientTokens) => {
  const encodedToken = Buffer.from(JSON.stringify(token)).toString("base64");
  localStorage.setItem(
    `${client}-${appName}-${LOCAL_STORAGE_SUFFIX}`,
    encodedToken
  );
};

const setToStorage = (key: string, event: string): void => {
  localStorage.setItem(key, event);
};

const getFromStorage = (key: string): string | null => {
  return localStorage.getItem(key);
};

const deleteFromStorage = (key: string): void => {
  localStorage.removeItem(key);
};

export {
  getFPKT,
  removeFPKT,
  setFPKT,
  setToStorage,
  getFromStorage,
  deleteFromStorage,
};
